const regObj = {
  // regName: /^[\u4E00-\u9FA5\uf900-\ufa2da-zA-Z]{1}[\u4E00-\u9FA5\uf900-\ufa2da-zA-Z·]{1,19}$/, // 校验姓名
  regName: /[\u4E00-\u9FA5\uf900-\ufa2da-zA-Z· ]{1,20}$/, // 校验姓名
  regUserName: /^[a-zA-Z0-9@]{6,16}$/, // 6-16位大小写字母、数字、@符号
  zipCode: /^[0-9]{6}$/,
  regTel: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, // 校验手机号
  regPassword: /^[a-zA-Z0-9]{8,18}$/, // 8-18位大小写字母、数字、符号去掉@\$\^\.\*\\?
  regTelNum: /^[0-9\-]{6,15}$/, // 校验电话号码
  regFixTel: /^[0-9\-]{7,12}$/,// 固定电话
  regFax: /^(\d{3,4}-)?\d{7,8}$/, // 传真
  regQQ: /^[1-9][0-9]{4,11}$/, // 校验 5~11位QQ号
  regWX: /^[a-zA-Z1][a-zA-Z0-9_-]{5,19}$/, //微信号
  regEmail: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,3}$/, // 校验邮箱
  //regEmail: /^[a-zA-Z0-9]+(([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){4,60}$)([a-z0-9]{2,6}$)/, // 校验邮箱
  regCompanyName: /^[\u4E00-\u9FA5\uf900-\ufa2da-z\.\s\,\(\)（）]{8,50}$/i, // 校验公司名字
  regInvoiceCode: /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, // 校验纳税识别号
  // regCardNo:  /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, //身份证验证
  regCardNo: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/, //身份证验证
  // regCardFZ: /(^[EeKkGgDdSsPpHh]\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\d{7}$)/, // 护照验证
  regCardFZ: /(^[a-zA-Z][a-zA-Z0-9]{3,15}$)/, // 护照验证4〜16以字母开头的数字和字母字符
  regPrice: /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/, // 价格、金额类验证
  regBankCount: /^([1-9]{1})(\d{15}|\d{17}|\d{18})$/, // 校验银行卡号
  regSocialCode: /([a-zA-Z0-9]{18}$)/, // 18位统一社会信用代码
  regCarNum: /[\u4E00-\u9FA5\uf900-\ufa2dA-Z0-9]{1,10}$/, // 最大10位字母数字汉字车牌号
  regCarDec: /^.{10,2000}/, // 车辆简介 20~2000字符
  regDesc: /^.{240,600}/,
  regNum2: /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/,
  regWebsite: /^(?=^.{3,256}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/, // 256字符字母、数字、符号的网址
  regGroupName: /^[a-zA-Z\u4e00-\u9fa5][a-zA-Z0-9\u4e00-\u9fa5]*$/,
  regCodeRange: /(^[1-9]\d*$)/,
}

let checkTFObj = {}

for (let k in regObj) {
  let _str = 'check' + k.substring(3) + 'R'
  checkTFObj[_str] = (value) => {
    let _value = value.trim()
    if (_value.length != 0) {
      if (!regObj[k].test(_value)) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }
}
export const checkNameR = (value) => {
  let _value = value.trim()
  if (_value.length != 0) {
    let _reg = /^[\u4E00-\u9FA5\uf900-\ufa2da-zA-Z]{1}[\u4E00-\u9FA5\uf900-\ufa2da-zA-Z·]{1,20}$/
    if (!_reg.test(_value)) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

// 校验姓名
export const checkName = (rule, value, callback) => {
  // let _value = value.trim()
  if (value.length != 0) {
    if (!regObj.regName.test(value)) {
      callback(new Error('请输入2到20位的合法姓名'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}


// 校验手机号
export const checkTel = (rule, value, callback) => {
  if (value) {
    if (!regObj.regTel.test(value)) {
      callback(new Error('请输入合法的手机号码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验新手机号
export const checkTelN = (rule, value, callback) => {
  if (value) {
    if (!regObj.regTel.test(value)) {
      callback(new Error('请输入合法的手机号码'))
    } else {
      callback()
    }
  } else {
    callback('请输入新的手机号码')
  }
}
// 校验QQ号
export const checkQQ = (rule, value, callback) => {
  if (value) {
    if (!regObj.regQQ.test(value)) {
      callback(new Error('请输入合法的QQ号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验微信号
export const checkWX = (rule, value, callback) => {
  if (value) {
    if (!regObj.regWX.test(value)) {
      callback(new Error('请输入合法的微信号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

// 校验电话号码
export const checkTelNum = (rule, value, callback) => {
  // let _value = value.trim()
  if (value.length != 0) {
    if (!regObj.regTelNum.test(value)) {
      callback(new Error('请输入合法的电话号码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验固定电话
export const checkFixTel = (rule, value, callback) => {
  // let _value = value.trim()
  if (value.length != 0) {
    if (!regObj.regFixTel.test(value)) {
      callback(new Error('请输入合法的固定号码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验传真
export const checkFixCz = (rule, value, callback) => {
  // let _value = value.trim()
  if (value.length != 0) {
    if (!regObj.regFixTel.test(value)) {
      callback(new Error('请输入合法的传真'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验邮箱
export const checkPrice = (rule, value, callback) => {
  if (value) {
    if (!regObj.regPrice.test(value)) {
      callback(new Error('请输入合法的金额'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验邮箱
export const checkEmail = (rule, value, callback) => {
  if (value) {
    if (!regObj.regEmail.test(value)) {
      callback(new Error('请输入合法的邮箱'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验新邮箱
export const checkEmails = (rule, value, callback) => {
  if (value) {
    if (!regObj.regEmail.test(value)) {
      callback(new Error('请输入合法的邮箱'))
    } else {
      callback()
    }
  } else {
    callback('请输入要绑定的新邮箱')
  }
}
// 校验公司名字
export const checkCompanyName = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    // let _reg = /^(([\u4e00-\u9fff]{2,50})|([a-z\.\s\,\(\)（）]{1,50}))$/i;
    if (!regObj.regCompanyName.test(_value)) {
      callback(new Error('企业名称应符合规则，不少于8个字符'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验网址
export const checkWebsite = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    if (!regObj.regWebsite.test(_value)) {
      callback(new Error('请输入合法网址'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 校验统一社会信用代码
export const checkSocialCode = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    if (!regObj.regSocialCode.test(_value)) {
      callback(new Error('请输入合法统一社会信用代码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

/** function _checkAddressCode(addressCode){
    var provinceAndCitys={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",
        31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",
        45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",
        65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"};
    var check = /^[1-9]\d{5}$/.test(addressCode);
    if(!check) return false;
    if(provinceAndCitys[parseInt(addressCode.substring(0,2))]){
        return true;
    }else{
        return false;
    }
}

 function _isValidOrgCode(value){
    if(value!=""){
        var part1=value.substring(0,8);
        var part2=value.substring(value.length-1,1);
        var ws = [3, 7, 9, 10, 5, 8, 4, 2];
        var str = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var reg = /^([0-9A-Z]){8}$/;
        if (!reg.test(part1))
        {
            return true
        }
        var sum = 0;
        for (var i = 0; i< 8; i++)
        {
            sum += str.indexOf(part1.charAt(i)) * ws[i];
        }
        var C9 = 11 - (sum % 11);
        var YC9=part2+'';
        if (C9 == 11) {
            C9 = '0';
        } else if (C9 == 10) {
            C9 = 'X' ;
        } else {
            C9 = C9+'';
        }
        return YC9!=C9;
    }
} **/

// 校验纳税号
export const checkInvoiceCode = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    if (!regObj.regInvoiceCode.test(_value)) {
      callback(new Error('请填写正确的纳税号码'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}

// 非EL
checkTFObj.checkInvoiceCodeR = (value) => {
  let _value = value.trim()
  if (_value.length != 0) {
    let _reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
    if (!_reg.test(_value)) {
      return '请填写正确的纳税号码'
    } else {
      return true
    }
  } else {
    return true
  }
}
// 校验身份证号
export const checkCardNo = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入正确的身份证号'))
  } else {
    let _value = value.trim()
    if (_value.length != 0) {
      if (!regObj.regCardNo.test(_value)) {
        callback(new Error('请输入正确的身份证号'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }

}
// 校验护照号
export const checkCardFZ = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    if (!regObj.regCardFZ.test(_value)) {
      callback(new Error('请输入正确的护照号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 
// 校验银行卡号
export const checkBankCount = (rule, value, callback) => {
  let _value = value.trim()
  if (_value.length != 0) {
    if (!regObj.regBankCount.test(_value)) {
      callback(new Error('请输入正确的银行卡号'))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
// 字符串截取，中文按两个字符
export const setString = (str, len) => {
  var strlen = 0;
  var s = "";
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) {
      strlen += 2;
    } else {
      strlen++;
    }
    s += str.charAt(i);
    if (strlen >= len) {
      return s;
    }
  }
  return s;
}
export const regAll = regObj;
export let checkTF = checkTFObj;